import { gql } from 'urql';

export const NucleusModelListQuery = gql`
  query NucleusModelList($limit: Int) {
    viewer {
      __typename
      id
    }

    nucleusModelProjects(limit: $limit) {
      ...modelProjectFields
    }
  }

  fragment modelProjectFields on NucleusModelProject {
    __typename
    id
    ref_id
    name
    is_public
    metadata
    bundle_name
    created_at
    tags
    trainedSliceIds
    evaluationsCount
    archived
    modelRuns {
      __typename
      id
      name
      metadata
      started_at
      status
      dataset {
        name
      }
    }
  }
`;

export * from './useNucleusModelList.generated';
